import { Component, OnInit, Input } from '@angular/core';
import { Tool, Company, ProjectService, ProjectTool, Partecipant } from 'toolbandi-ui-lib';
import { Search, CrudService, MessageService, Page } from 'elbuild-ui-lib-core';
import { TranslateService } from '@ngx-translate/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-project-tool-add',
	templateUrl: './project-tool-add.component.html',
	styleUrls: ['./project-tool-add.component.scss']
})
export class ProjectToolAddComponent implements OnInit {

	@Input()
	projectid: number;

	associablerows: Tool[] = [];
	allassociablerows: Tool[] = [];

	associaterows: ProjectTool[] = [];
	allassociaterows: ProjectTool[] = [];

	associableloading = true;
	associateloading = true;

	partecipants: Partecipant[];
	@Input()
	companyid: number;

	@Input()
	singlecompany: boolean;


	advancedSearch = new Search('projecttool join tool on projecttool.toolid = tool.id');


	constructor(
		private projectService: ProjectService,
		private activeModal: NgbActiveModal,
		private crudService: CrudService<ProjectTool>,
		private partecipantService: CrudService<Partecipant>,
		private messageService: MessageService,
		private translateService: TranslateService
	) { }

	ngOnInit() {
		const search = new Search('partecipant');
		search.addSimpleFilter('entity', 'company');
		this.partecipantService.searchEntities(Partecipant, 'partecipant', search, search.page).subscribe((data: Partecipant[]) => {
			this.partecipants = data;
		});
	}

	loadAssociabletools(): void {
		this.associableloading = true;
		this.projectService.getAssociableTools(this.projectid, +this.companyid).subscribe((data: Tool[]) => {
			this.associablerows = data;
			this.allassociablerows = data;
			this.associableloading = false;
		});
	}

	loadAssociatetools(): void {
		this.associateloading = true;
		this.associaterows = [];

		if (this.projectid) {
			this.advancedSearch.addSimpleFilter('projecttool.projectid', this.projectid);
		}

		if (+this.companyid) {
			this.advancedSearch.addSimpleFilter('tool.companyid', this.companyid);
		} else {
			this.advancedSearch.removeSimpleFilter('tool.companyid');
		}

		this.crudService.searchEntities(ProjectTool, 'projecttool', this.advancedSearch, new Page(1000)).subscribe((data: ProjectTool[]) => {
			this.associaterows = data;
			this.allassociaterows = data;
			this.associateloading = false;
		}, ({ error }) => {
			this.messageService.sendError(error, this.translateService.instant('labels.error-occurred'));
			this.associateloading = false;
		});
	}

	dismiss(): void {
		this.activeModal.dismiss();
	}

	add(tool: Tool): void {

		const projecttool = new ProjectTool();
		projecttool.projectid = this.projectid;
		projecttool.toolid = tool.id;

		this.crudService.createEntity(ProjectTool, 'projecttool', projecttool).subscribe((res) => {
			this.messageService.sendSuccess(
				this.translateService.instant('labels.tool-add-success'),
				this.translateService.instant('labels.success')
			);
			this.loadAssociabletools();
			this.loadAssociatetools();
		}, ({ error }) => {
			this.messageService.sendError(
				error.msg ? error.msg : error,
				this.translateService.instant('labels.event-save-error')
			);
		});
	}

	remove(projecttool: ProjectTool): void {


		this.crudService.deleteEntity(ProjectTool, 'projecttool', projecttool).subscribe((res) => {
			this.messageService.sendSuccess(
				this.translateService.instant('labels.tool-remove-success'),
				this.translateService.instant('labels.success')
			);
			this.loadAssociabletools();
			this.loadAssociatetools();
		}, ({ error }) => {
			this.messageService.sendError(
				error.msg ? error.msg : error,
				this.translateService.instant('labels.event-save-error')
			);
		});
	}

	updateFilter(event): void {
		const val = event.target.value.toLowerCase();

		if (val) {
			this.associablerows = this.allassociablerows.filter(e => {
				return e.name?.toLowerCase().indexOf(val) >= 0;
			});
			this.associaterows = this.allassociaterows.filter(e => {
				return e.name?.toLowerCase().indexOf(val) >= 0;
			});

		} else {
			this.associablerows = this.allassociablerows.filter(tool => true);
			this.associaterows = this.allassociaterows.filter(tool => true);
		}
	}

	reloadtools(): void {
		this.loadAssociabletools();
		this.loadAssociatetools();
	}

	get page() {
		if (this.advancedSearch) {
			return this.advancedSearch.page;
		} else {
			return undefined;
		}
	}

	onPageChange(pageInfo: any) {
		this.advancedSearch.page.setPageNumber(pageInfo.offset);
		this.loadAssociatetools();
	}

	onSortChange(sortInfo: any) {
		const sort = sortInfo.sorts[0];
		this.advancedSearch.setSortField(sort.prop);
		this.advancedSearch.setSortDirection(sort.dir);
		this.loadAssociatetools();
	}

}
